module.exports = __webpack_public_path__ + "img/india.1e048a92.svg";